import { useCallback, type ChangeEvent } from "react";
import { Checkbox } from "@mantine/core";

interface NoPatientBillingCheckboxProps {
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

export function NoPatientBillingCheckbox({
  checked,
  disabled,
  onChange,
}: NoPatientBillingCheckboxProps) {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.currentTarget.checked);
    },
    [onChange]
  );

  return (
    <Checkbox
      label="No patient billing and insurance info not required"
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
    />
  );
}
